// Libs
import React from "react";
import moment from "moment-timezone";
import propTypes from "prop-types";
import { Descriptions, Skeleton, Tag } from "antd";
import { useSDKTenants } from "hooks/tenants-sdk";
import { useParams } from "react-router-dom";

function DashboardSettingsGeneral(props) {
  const params = useParams();

  //#region Tenant Hooks
  const { data: tenantDetails } = useSDKTenants({ tenantName: params.tenant });
  const isTrialTenant = tenantDetails?.isTrial;
  //#endregion

  return (
    <>
      {!tenantDetails && (
        <div>
          <Skeleton />
        </div>
      )}
      {tenantDetails && (
        <section>
          <Descriptions title={"Tenant Info"}>
            <Descriptions.Item label="Name">
              {tenantDetails?.displayName}
            </Descriptions.Item>
            <Descriptions.Item label="Customer ID">
              {tenantDetails.customerId || "-"}
            </Descriptions.Item>
            <Descriptions.Item label="Subscription ID">
              {tenantDetails.subscriptionId || "-"}
            </Descriptions.Item>
            <Descriptions.Item label="Plan">
              {
                <Tag
                  color={
                    tenantDetails?.plan?.includes("advance")
                      ? "magenta"
                      : tenantDetails?.plan?.includes("pro")
                      ? "blue"
                      : tenantDetails?.plan?.includes("enterprise")
                      ? "gold"
                      : "default"
                  }
                >
                  {tenantDetails?.plan?.includes("advance")
                    ? "ADVANCE"
                    : tenantDetails?.plan?.includes("pro")
                    ? "PRO"
                    : tenantDetails?.plan?.includes("enterprise")
                    ? "ENTERPRISE"
                    : "FREE"}
                </Tag>
              }

              {isTrialTenant && <Tag color="gold">TRIAL</Tag>}
            </Descriptions.Item>
            <Descriptions.Item label="Plan Interval">
              {
                <div>
                  {tenantDetails.planInterval
                    ? tenantDetails.planInterval === "monthly"
                      ? "Monthly"
                      : "Yearly"
                    : ""}
                </div>
              }
            </Descriptions.Item>
            {!isTrialTenant && (
              <Descriptions.Item label="Expired Date">
                {tenantDetails.currentPeriodEnd
                  ? moment(tenantDetails.currentPeriodEnd).format("YYYY-MM-DD")
                  : "-"}
              </Descriptions.Item>
            )}
            {isTrialTenant && (
              <Descriptions.Item label="Trial Start Date">
                {tenantDetails.trialPeriodStart
                  ? moment(tenantDetails.trialPeriodStart).format("YYYY-MM-DD")
                  : "-"}
              </Descriptions.Item>
            )}
            {isTrialTenant && (
              <Descriptions.Item label="Trial Expired Date">
                {tenantDetails.trialPeriodEnd
                  ? moment(tenantDetails.trialPeriodEnd).format("YYYY-MM-DD")
                  : "-"}
              </Descriptions.Item>
            )}
          </Descriptions>
        </section>
      )}
    </>
  );
}

DashboardSettingsGeneral.propTypes = {
  currentTenant: propTypes.any,
};

export default DashboardSettingsGeneral;
